import { supabase, bookingApiUrl } from './supabase'
import type { InvoiceTarget } from '../../supabase/functions/_shared/invoice-model'
export async function invoiceRequest<T>(body: Record<string, unknown>, pdf = false): Promise<T> {
  const { data } = await supabase.auth.getSession()
  if (!data.session) throw new Error('Sign in to the admin again.')
  const response = await fetch(bookingApiUrl.replace(/booking-api$/, 'admin-invoices'), {
    method: 'POST', headers: { Authorization: `Bearer ${data.session.access_token}`, 'Content-Type': 'application/json', apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY }, body: JSON.stringify(body),
  })
  if (!response.ok) {
    const decoded = await response.json().catch(() => null)
    const payload = decoded && typeof decoded === 'object' ? decoded : {}
    if (response.status === 546 || ['WORKER_RESOURCE_LIMIT', 'WORKER_LIMIT'].includes(payload.code)) {
      throw new Error('Invoice processing was interrupted by the server’s resource limit. Refresh invoices to check saved progress and when you can retry.')
    }
    throw new Error(typeof payload.error === 'string' ? payload.error : 'The invoice request failed. Please retry.')
  }
  return (pdf ? await response.blob() : await response.json()) as T
}
// Keep all existing operational saves and their validation. Only close links when
// the database explicitly reports that they prevent a manual paid-status update.
export async function saveWithInvoiceClosure<T>(save: () => Promise<T>, target: InvoiceTarget): Promise<T> {
  try { return await save() }
  catch (error) {
    const message = error && typeof error === 'object' && 'message' in error ? String(error.message) : String(error)
    if (!message.includes('INVOICE_LINK_OPEN')) throw error
    await invoiceRequest({ action: 'close_target', target })
    return save()
  }
}
